module.exports = __webpack_public_path__ + "img/msg2.b2097b88.svg";